import React, { useEffect, useState } from 'react'
import {
  Button,
  ButtonGroup,
  Col,
  FormGroup,
  Input,
  Row,
  Alert,
} from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import Switch from 'react-switch/index'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import Select from 'react-select'
import {
  fruitContainerTypeOptions,
  fruitProductOptions,
  fruitTypeOptions,
  productTypeOptions,
  vegContainerTypeOptions,
  vegProductOptions,
  vegTypeOptions,
} from './constants'
import PropTypes from 'prop-types'
import { isNotAlpha, isNotNumericDecimal } from 'context/Utilities'

const CannedVegsFruitsPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    ItemType: item.ItemType,
    Size: item.Size,
    ContainerType: item.ContainerType,
    Packaged: item.Packaged,
    OrganicVerification: item.OrganicVerification,
    VegetablePackageCertification: item.VegetablePackageCertification,
    SaltContent: item.SaltContent,
    PackedIn: item.PackedIn,
    FruitPackageCertification: item.FruitPackageCertification,
    CannedProductType: item.CannedProductType,
  })
  const [productOptions, setProductOptions] = useState(
    item.CannedProductType === 'Fruit' ? fruitProductOptions : vegProductOptions
  )

  const tempType = {
    value: item.ItemType,
    label: item.ItemType,
  }
  const tempContainerType = {
    value: item.ContainerType,
    label: item.ContainerType,
  }

  let containsType
  let containsContainerType

  if (item.CannedProductType === 'Fruit') {
    containsType = fruitTypeOptions.some(e => {
      return JSON.stringify(tempType) === JSON.stringify(e)
    })

    containsContainerType = fruitContainerTypeOptions.some(e => {
      return JSON.stringify(tempContainerType) === JSON.stringify(e)
    })
  } else {
    containsType = vegTypeOptions.some(e => {
      return JSON.stringify(tempType) === JSON.stringify(e)
    })

    containsContainerType = vegContainerTypeOptions.some(e => {
      return JSON.stringify(tempContainerType) === JSON.stringify(e)
    })
  }

  if (containsType) {
    packaging.ItemType = item.ItemType
  } else {
    packaging.ItemType = 'Other'
    packaging.otherType = item.ItemType
    item.otherType = item.ItemType
    item.ItemType = 'Other'
  }
  if (containsContainerType) {
    packaging.ContainerType = item.ContainerType
  } else {
    packaging.ContainerType = 'Other'
    packaging.otherContainerType = item.ContainerType
    item.otherContainerType = item.ContainerType
    item.ContainerType = 'Other'
  }

  const methods = useFormContext()
  const {
    setSelectReviewer,
    setSwitchReviewer,
    onChangeReviewer,
    asterisk,
  } = useFormUtils()

  useEffect(() => {
    if (item !== null) {
      const {
        fkCategory,
        fkSubCategory,
        ItemType,
        Size,
        ContainerType,
        Packaged,
        OrganicVerification,
        VegetablePackageCertification,
        SaltContent,
        PackedIn,
        FruitPackageCertification,
        CannedProductType,
      } = item
      setPackaging({
        fkCategory,
        fkSubCategory,
        ItemType,
        Size,
        ContainerType,
        Packaged,
        OrganicVerification,
        VegetablePackageCertification,
        SaltContent,
        PackedIn,
        FruitPackageCertification,
        CannedProductType,
      })
      setProductOptions(
        item.CannedProductType === 'Fruit'
          ? fruitProductOptions
          : vegProductOptions
      )
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item])

  console.log('item is: ' + JSON.stringify(item))

  return (
    <Row>
      <Col xs={12} md={4} lg={4}>
        <p>
          <strong>Canned Product Type {asterisk}</strong>
        </p>
        <ButtonGroup>
          <Button
            outline
            color="success"
            className="btn-round"
            active={item.CannedProductType === productTypeOptions[0]}
            disabled={item.CannedProductType !== productTypeOptions[0]}
            size="sm"
          >
            {productTypeOptions[0]}
          </Button>
        </ButtonGroup>
        <ButtonGroup>
          <Button
            outline
            color="success"
            className="btn-round"
            active={item.CannedProductType === productTypeOptions[1]}
            disabled={item.CannedProductType !== productTypeOptions[1]}
            size="sm"
          >
            {productTypeOptions[1]}
          </Button>
        </ButtonGroup>
        <br />
        <p>
          <strong>Type {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={productOptions.typeOptions}
          defaultValue={{ label: item.ItemType, value: item.ItemType }}
          name="ItemType"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Type'}
          onChange={([selected, value]) => {
            setSelectReviewer(item, selected, value)
            setPackaging({
              ...packaging,
              ItemType: value,
            })
            return selected
          }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="ItemType"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        {item?.ItemType === 'Other' && (
          <FormGroup>
            <p>
              <strong>Other Type (Please Specify) {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="otherType"
              placeholder={'Other Type'}
              defaultValue={item.otherType}
              control={methods.control}
              rules={{ required: true }}
              onKeyDown={e => {
                if (isNotAlpha(e.key)) {
                  e.preventDefault()
                }
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="otherType"
                message={'Other type is required.'}
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        )}
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            name="Size"
            placeholder={'Size'}
            defaultValue={item.Size}
            control={methods.control}
            rules={{ required: true, maxLength: 5 }}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            onChange={([event]) => {
              onChangeReviewer(item, event)
              return event
            }}
            disabled={isDisabled}
          />
          <p className={'text-danger'}>
            {methods.errors.Size && methods.errors.Size.type === 'required' && (
              <Alert color="danger" className={'mt-3'}>
                ⚠ Size is required.
              </Alert>
            )}
            {methods.errors.Size && methods.errors.Size.type === 'maxLength' && (
              <Alert color="danger" className={'mt-3'}>
                ⚠ Size exceeds 5 characters.
              </Alert>
            )}
          </p>
        </FormGroup>
      </Col>
      <Col xs={12} md={4} lg={4}>
        <p>
          <strong>Container Type {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={productOptions.containerTypeOptions}
          defaultValue={{
            label: item.ContainerType,
            value: item.ContainerType,
          }}
          name="ContainerType"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Container Type'}
          onChange={([selected, value]) => {
            setSelectReviewer(item, selected, value)
            setPackaging({
              ...packaging,
              ContainerType: value,
            })
            return selected
          }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="ContainerType"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        {item?.ContainerType === 'Other' && (
          <FormGroup>
            <p>
              <strong>Other Container Type (Please Specify) {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="otherContainerType"
              placeholder={'Other Type'}
              defaultValue={item.otherContainerType}
              control={methods.control}
              rules={{ required: true }}
              onKeyDown={e => {
                if (isNotAlpha(e.key)) {
                  e.preventDefault()
                }
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="otherContainerType"
                message={'Other container type is required.'}
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        )}
        <p>
          <strong>
            {productOptions.packTypeTitle} {asterisk}
          </strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={productOptions.packTypeOptions}
          defaultValue={
            item.CannedProductType === 'Fruit'
              ? { label: item.PackedIn, value: item.PackedIn }
              : { label: item.SaltContent, value: item.SaltContent }
          }
          name="packageType"
          control={methods.control}
          rules={{ required: true }}
          placeholder={productOptions.packTypePlaceholder}
          onChange={([selected]) => {
            item.CannedProductType === 'Fruit'
              ? (item.PackedIn = selected.value)
              : (item.SaltContent = selected.value)
            return selected
          }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="packageType"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <p>
          <strong>Packaged {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={productOptions.packSizeOptions}
          defaultValue={{ label: item.Packaged, value: item.Packaged }}
          name="Packaged"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Package Size'}
          onChange={([selected, value]) => {
            setSelectReviewer(item, selected, value)
            return selected
          }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="Packaged"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
      </Col>
      <Col xs={12} md={4} lg={4}>
        <hr />
        <p>
          <strong>Organic</strong>
        </p>
        <Controller
          as={Switch}
          name="OrganicVerification"
          id="OrganicVerification"
          control={methods.control}
          defaultValue={item.OrganicVerification}
          onChange={([checked, event, id]) => {
            setSwitchReviewer(item, checked, event, id)
            return checked
          }}
          disabled={isDisabled}
        />
        <hr />
        <p>
          <strong>
            {productOptions.noAdditionalIngredients} {asterisk}
          </strong>
        </p>
        <Controller
          as={Switch}
          name="noAddtlIngredients"
          id="noAddtlIngredients"
          onChange={([checked, event, id]) => {
            item.CannedProductType === 'Fruit'
              ? (item.FruitPackageCertification = checked)
              : (item.VegetablePackageCertification = checked)
            return checked
          }}
          control={methods.control}
          defaultValue={
            item.CannedProductType === 'Fruit'
              ? item.FruitPackageCertification
              : item.VegetablePackageCertification
          }
          rules={{
            validate: noAddtlIngredients => noAddtlIngredients === true,
          }}
          disabled={isDisabled}
        />
        <br />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="noAddtlIngredients"
            message={'⚠ Product must not have additional ingredients.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
      </Col>
    </Row>
  )
}

CannedVegsFruitsPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default CannedVegsFruitsPackageReview
